import {
 TimelineConnector,
 TimelineContent,
 TimelineDot,
 TimelineItem,
 TimelineSeparator,
} from '@mui/lab';
import { alpha, Button, Divider, Grid, Typography } from '@mui/material';
import useWindowDimensions from '../../../Hooks/useWindowDimensions';
import { Map } from './Map';
import OriginoQrLogo from '../../../Images/origino_qr.png'
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/styles';
import { translateFunc } from '../../../Helpers/translateFunc';

export const TimeLineCard = ({information, tt, logoWoText, enableExtraParams}) => {
  const { t } = useTranslation()
  const { width } = useWindowDimensions();
  const theme = useTheme()

 const downloadCertificate = (url) =>{
  var a = document.createElement('a');
  a.href=url;
  a.target = '_blank';
  document.body.appendChild(a);
  a.click();
}

const getLogoImage = (data) => {
  try {
    if (Object.keys(data).length === 0) {
      return logoWoText ?? OriginoQrLogo
    }

    let jsonValue = typeof data === 'object' && data !== null ? data : JSON.parse(data);
    return(jsonValue.publicFileURI);
  } catch (e) {
    return logoWoText ?? OriginoQrLogo
  }
}

const renderCertificates = (certificates) => {
  const fileData = JSON.parse(certificates.file);
  const buttonLabel = fileData.repositoryId === -1 ? t('qrTemplate.Abrir') : t('qrTemplate.Descargar'); 

  return (
    <Typography
      key={fileData.fileId}
      component='div'
      variant='body2'
      color={theme?.palette?.text?.primary}
      className='card-timeline-files'
    >
      <div style={{ display: 'flex', alignSelf: 'center' }}>
        <svg
          width='13'
          height='16'
          viewBox='0 0 13 16'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M11.7148 3.74609C11.9883 4.01953 12.125 4.35156 12.125 4.74219V14.4688C12.125 14.8594 11.9883 15.1914 11.7148 15.4648C11.4414 15.7383 11.1094 15.875 10.7188 15.875H2.28125C1.89062 15.875 1.55859 15.7383 1.28516 15.4648C1.01172 15.1914 0.875 14.8594 0.875 14.4688V2.28125C0.875 1.89063 1.01172 1.55859 1.28516 1.28516C1.55859 1.01172 1.89062 0.875 2.28125 0.875H8.25781C8.64844 0.875 8.98047 1.01172 9.25391 1.28516L11.7148 3.74609ZM11.041 4.41992L8.58008 1.95898C8.52148 1.90039 8.45312 1.85156 8.375 1.8125V4.625H11.1875C11.1484 4.54688 11.0996 4.47852 11.041 4.41992ZM10.7188 14.9375C10.8555 14.9375 10.9629 14.8887 11.041 14.791C11.1387 14.7129 11.1875 14.6055 11.1875 14.4688V5.5625H8.14062C7.94531 5.5625 7.7793 5.49414 7.64258 5.35742C7.50586 5.2207 7.4375 5.05469 7.4375 4.85938V1.8125H2.28125C2.14453 1.8125 2.02734 1.86133 1.92969 1.95898C1.85156 2.03711 1.8125 2.14453 1.8125 2.28125V14.4688C1.8125 14.6055 1.85156 14.7129 1.92969 14.791C2.02734 14.8887 2.14453 14.9375 2.28125 14.9375H10.7188ZM10.0742 9.92773C10.2695 10.084 10.3184 10.3184 10.2207 10.6309C10.123 10.9434 9.89844 11.0996 9.54688 11.0996C8.98047 11.0996 8.3457 10.9141 7.64258 10.543C7.29102 10.582 6.49023 10.8164 5.24023 11.2461C4.88867 11.832 4.58594 12.2715 4.33203 12.5645C4.05859 12.8574 3.78516 13.0234 3.51172 13.0625C3.23828 13.082 3.0332 13.0234 2.89648 12.8867C2.7793 12.7305 2.73047 12.5645 2.75 12.3887C2.86719 11.9004 3.44336 11.3828 4.47852 10.8359C4.84961 10.2109 5.25977 9.35156 5.70898 8.25781C5.43555 7.16406 5.35742 6.40234 5.47461 5.97266C5.51367 5.79688 5.63086 5.67969 5.82617 5.62109C6.02148 5.54297 6.2168 5.55273 6.41211 5.65039C6.62695 5.72852 6.75391 5.9043 6.79297 6.17773C6.89062 6.49023 6.82227 7.125 6.58789 8.08203C6.88086 8.82422 7.32031 9.37109 7.90625 9.72266C9.05859 9.56641 9.78125 9.63477 10.0742 9.92773ZM3.36523 12.5352C3.36523 12.5547 3.4043 12.5352 3.48242 12.4766C3.56055 12.418 3.67773 12.291 3.83398 12.0957C4.00977 11.9004 4.19531 11.6465 4.39062 11.334C3.78516 11.9004 3.44336 12.3008 3.36523 12.5352ZM6.14844 6.03125C6.12891 6.03125 6.10938 6.10938 6.08984 6.26562C6.08984 6.42187 6.09961 6.61719 6.11914 6.85156C6.13867 7.08594 6.16797 7.27148 6.20703 7.4082C6.30469 7.27148 6.34375 7.00781 6.32422 6.61719C6.32422 6.22656 6.26562 6.03125 6.14844 6.03125ZM5.32812 10.6895C6.32422 10.2988 6.94922 10.084 7.20312 10.0449C6.77344 9.73242 6.42188 9.32227 6.14844 8.81445C5.85547 9.5957 5.58203 10.2207 5.32812 10.6895ZM9.81055 10.5137C9.92773 10.4355 9.86914 10.3672 9.63477 10.3086C9.36133 10.2305 9 10.2109 8.55078 10.25C8.86328 10.3867 9.12695 10.4844 9.3418 10.543C9.55664 10.582 9.69336 10.582 9.75195 10.543L9.81055 10.5137Z'
            fill={theme?.palette?.primary?.main}
          />
        </svg>
        <p className='mt-0 pl-1'> {certificates.name ? certificates.name : 'Documento'}</p>
      </div>
      <Button
        style={{
          width: '40px',
          backgroundColor: theme?.palette?.primary?.main,
          borderRadius: '4px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          color: 'white',
          fontSize: '12px',
          fontWeight: '400',
          lineHeight: '14px',
          textTransform: 'none',
          marginRight:'40px'
        }}
        onClick={() => downloadCertificate(fileData.publicFileURI)}
      >
        {buttonLabel}
      </Button>
    </Typography>
  );
}

 return (
  <TimelineItem>
    {width < 651 ? (
      <>
        <TimelineSeparator>
          <TimelineDot
            style={{
              background: theme?.palette?.secondary?.main ?? '#FFFFFF',
              boxShadow: `10px 10px 20px ${alpha(theme?.palette?.primary?.main ?? 'rgba(53, 91, 173)', 0.1)}`,
              borderRadius: '100px',
              width: 125,
              height: 75,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 12,
            }}
            className='m-0'
          >
            <img
              src={getLogoImage(information.logo)}
              alt='facility logo'
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
              }}
            />
          </TimelineDot>
          <TimelineConnector 
            sx={{
              backgroundColor: theme?.palette?.primary?.main
            }}
          />
        </TimelineSeparator>
        <TimelineContent className='pr-0 pt-1 pl-0 mt-1 mb-2 d-flex'>
          <Grid container>
          <Grid item xs={12} className='p-0 pl-1' style={{ maxHeight: '300px' }}>
            <Typography variant='subtitle2' color={theme?.palette?.text?.primary}>
            {information.title}
            </Typography>
            <Typography variant='body2' color={theme?.palette?.text?.primary}>
            {information.countryFlag} {information.country}
            </Typography>
            <Typography variant='body2' color={theme?.palette?.text?.primary}>
            { information.startDate!==null?tt('qrTemplate.Desde')+` ${information.startDate}` : ''}
            { information.endDate!==null?tt('qrTemplate.Hasta')+` ${information.endDate}` : ''}
            </Typography>
            {( 
              information?.extraParams?.filter(field => field.data).length > 0 
              && enableExtraParams.someTrue 
            ) && (
              <>
                <Typography variant='body2' color={theme?.palette?.text?.primary} sx={{ textDecoration: 'underline' }}>
                  {tt('qrTemplate.extraParams')}
                </Typography>
                {information?.extraParams?.map(extraParam =>  (enableExtraParams.data?.[`timeLine_def_${extraParam.name}`] && extraParam?.data) &&
                    <Typography variant='body2' color={theme?.palette?.text?.primary}>
                      { '○ ' + tt('qrTemplate.'+extraParam.label) + ': ' + extraParam.data}
                    </Typography>
                )}
              </>
            )}
            {(information.email || information.webpage) && (
              <>
                <Typography variant='body2' color={theme?.palette?.text?.primary} sx={{ textDecoration: 'underline' }}>
                  {tt('qrTemplate.contact')}
                </Typography>
                {information.webpage && <Typography variant='body2' color={theme?.palette?.text?.primary}>
                  { '○ ' + tt('qrTemplate.website') + ': ' + information.webpage}
                </Typography>}
                {information.email && <Typography variant='body2' color={theme?.palette?.text?.primary}>
                  { '○ ' + tt('qrTemplate.email') + ': ' + information.email}
                </Typography>}
              </>
            )}
          </Grid>
          <Grid item xs={12} style={{ minHeight: '140px' }} className='mt-2'>
            { information.lat!==null && information.lon!==null && <Map information={information}/>}
          </Grid>
          <Grid
            item
            xs={12}
            className='p-0 pl-1 pt-2'
            style={{ maxHeight: '300px' }}
          >
            {information.certificates?.company?.length > 0 &&
              <>
                <Typography 
                  variant='body2' 
                  color={theme?.palette?.text?.primary} 
                  sx={{ 
                    textDecoration: 'underline',
                    marginBottom: 1
                  }}
                >
                  {t('qrTemplate.certCompany')}:
                </Typography>
                {information.certificates.company.map((c) => renderCertificates(c))}
                {information.certificates.box?.length > 0 && <Divider sx={{ my: 2 }} />}
              </>
            }
            {information.certificates?.box?.length > 0 &&
              <>
                <Typography 
                  variant='body2' 
                  color={theme?.palette?.text?.primary} 
                  sx={{ 
                    textDecoration: 'underline',
                    marginBottom: 1
                  }}
                >
                  {t('qrTemplate.certBox')}:
                </Typography>
                {information.certificates.box.map((c) => renderCertificates(c))}
              </>
            }
          </Grid>
          </Grid>
        </TimelineContent>
      </>
    ) : (
      <>
        <TimelineSeparator>
          <TimelineDot
            style={{
              background: theme?.palette?.secondary?.main ?? '#FFFFFF',
              boxShadow: `10px 10px 20px ${alpha(theme?.palette?.primary?.main ?? 'rgba(53, 91, 173)', 0.1)}`,
              borderRadius: '100px',
              width: 125,
              height: 75,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 12,
            }}
            className='m-0'
          >
            <img
              src={getLogoImage(information.logo)}
              alt='facility logo'
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
              }}
            />
          </TimelineDot>
          <TimelineConnector 
            sx={{
              backgroundColor: theme?.palette?.primary?.main,
            }}
          />
        </TimelineSeparator>

        <TimelineContent className='pr-0 pt-2 pl-4 mt-1 mb-2'>
          <Grid container spacing={2}>
          <Grid item xs={6} className='p-0 pl-1'>
            <Typography variant='subtitle2' color={theme?.palette?.text?.primary}>
            {information.title}
            </Typography>
            {information?.tipo!=='' && information?.tipo && <Typography variant='body2' color={theme?.palette?.text?.primary}>
              {translateFunc(tt, `basicFormStepByStep.fieldTranslate.groupedmultiselectbox.rol.${information.tipoId}`, information.tipo)}
            </Typography>
          }
            {information.country!=='' && <Typography variant='body2' color={theme?.palette?.text?.primary}>
              {information.country}
            </Typography>
            }
            <Typography variant='body2' color={theme?.palette?.text?.primary}>
            { information.startDate!==null?tt('qrTemplate.Desde')+` ${information.startDate}` : ''}
            { information.endDate!==null?` ${tt('qrTemplate.Hasta')} ${information.endDate}` : ''}
            </Typography>
            {( 
              information?.extraParams?.filter(field => field.data).length > 0 
              && enableExtraParams.someTrue 
            ) && (
              <>
                <Typography variant='body2' color={theme?.palette?.text?.primary} sx={{ textDecoration: 'underline' }}>
                  {tt('qrTemplate.extraParams')}
                </Typography>
                {information?.extraParams?.map(extraParam => (
                  (Object.keys(enableExtraParams.data).length === 0 ||
                  enableExtraParams.data?.[`timeLine_def_${extraParam.name}`]
                  ) && extraParam?.data) && (
                    <Typography variant='body2' color={theme?.palette?.text?.primary}>
                      { '○ ' + tt('qrTemplate.'+extraParam.label) + ': ' + extraParam.data}
                    </Typography>
                  )
                )}
              </>
            )}
            {(information.email || information.webpage) && (
              <>
                <Typography variant='body2' color={theme?.palette?.text?.primary} sx={{ textDecoration: 'underline' }}>
                  {tt('qrTemplate.contact')}
                </Typography>
                {information.webpage && <Typography variant='body2' color={theme?.palette?.text?.primary}>
                  { '○ ' + tt('qrTemplate.website') + ': ' + information.webpage}
                </Typography>}
                {information.email && <Typography variant='body2' color={theme?.palette?.text?.primary}>
                  { '○ ' + tt('qrTemplate.email') + ': ' + information.email}
                </Typography>}
              </>
            )}
            <Divider sx={{ my: 2 }} /> 
            {information.certificates?.company?.length > 0 &&
              <>
                <Typography 
                  variant='body2' 
                  color={theme?.palette?.text?.primary} 
                  sx={{ 
                    textDecoration: 'underline',
                    marginBottom: 1
                  }}
                >
                  {t('qrTemplate.certCompany')}:
                </Typography>
                {information.certificates.company.map((c) => renderCertificates(c))}
                {information.certificates.box?.length > 0 && <Divider sx={{ my: 2 }} />}
              </>
            }
            {information.certificates?.box?.length > 0 &&
              <>
                <Typography 
                  variant='body2' 
                  color={theme?.palette?.text?.primary} 
                  sx={{ 
                    textDecoration: 'underline',
                    marginBottom: 1
                  }}
                >
                  {t('qrTemplate.certBox')}:
                </Typography>
                {information.certificates.box.map((c) => renderCertificates(c))}
              </>
            }
          </Grid>
          <Grid item xs={6} style={{minHeight:"200px"}} className='p-0 pl-1'>
            {
              information?.lat!==null && information?.lon!==null && 
              <Map information={information}/>
            }
          </Grid>
          </Grid>
        </TimelineContent>
      </>
    )}
    </TimelineItem>
  );
};
